// httpClient.ts
import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import config from '../Config/config'

const baseURL = config.apiBaseUrl; // Replace with your API base URL



const httpClient = axios.create({
  baseURL,
});

// Add a function to set the token in the headers
const setAuthToken = (token: string | null): void => {
  if (token) {
    httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete httpClient.defaults.headers.common['Authorization'];
  }
};

const get = async function <T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response: AxiosResponse<T> = await httpClient.get<T>(url, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };
  

const post = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.post(url, data, config);
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};

const del = async function <T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.delete(url, config);
    return response.data;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
};
const put = async function <T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await httpClient.put<T>(url, data, config);
    return response.data;
  } catch (error) {
    console.error('Error putting data:', error);
    throw error;
  }
};


// export const fetchData = (id: any, url: string, page: number, pageSize: number) => async (dispatch: any) => {
//   try {
//     const response = await post(url, { page, pageSize });
//     dispatch({ type: FETCH_DATA_SUCCESS, payload: { id, data: response } });
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// };
// export const fetchData = (id: any, url: string, page: number, pageSize: number) => async (dispatch: Dispatch) => {
//   try {
//     const response = await post(url, { page, pageSize });
//     dispatch(fetchDataSuccess(id, response)); // Dispatch the action with correct type
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// };



// export const fetchData = (id: any, url: string, page: number, pageSize: number) => async (dispatch: Dispatch<ActionTypes>) => {
//   try {
//     const response = await post(url, { page, pageSize });
//     dispatch(fetchDataSuccess(id, response)); // Dispatch the action with correct type
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// };

const http = {
  get,
  post,
  del,
  put,
  setAuthToken
};

export default http;
